import { CaretDoubleRight, Sparkle } from '@phosphor-icons/react';
import { Tooltip } from '@mantine/core';
import type { FC } from 'react';
import useQuickHelpContext from '@providers/QuickHelp/useQuickHelpContext';
import QuickHelpTabBar from './QuickHelpTabBar';
import QuickHelpChatArea from './QuickHelpChatArea';
import styles from './QuickHelpPanel.module.css';

const QuickHelpPanel: FC = () => {
    const { state, actions } = useQuickHelpContext();
    const activeTab = state.tabs.find((t) => t.id === state.activeTabId) ?? null;
    const isStreaming = activeTab?.isStreaming ?? false;

    return (
        <div className={`${styles.panel} ${isStreaming ? styles.panelStreaming : ''}`}>
            {/* Header */}
            <div className={styles.header}>
                <div className={styles.headerLeft}>
                    <span className={styles.headerIcon}>
                        <Sparkle size={13} weight="fill" />
                    </span>
                    <span className={styles.headerTitle}>AI Assistant</span>
                </div>

                {/* CaretDoubleRight = "collapse to the right" — mirrors the
                    CaretDoubleRight in the page header that opens the panel */}
                <Tooltip label="Close" position="left" withArrow openDelay={300}>
                    <button
                        type="button"
                        className={styles.collapseButton}
                        onClick={actions.closePanel}
                        aria-label="Close AI panel"
                    >
                        <CaretDoubleRight size={12} weight="bold" />
                    </button>
                </Tooltip>
            </div>

            {/* Tab bar */}
            <QuickHelpTabBar
                tabs={state.tabs}
                activeTabId={state.activeTabId}
                onSelectTab={actions.setActiveTab}
                onCloseTab={actions.closeTab}
                onNewTab={() => actions.createTab()}
            />

            {/* Active tab chat */}
            {activeTab ? (
                <QuickHelpChatArea tab={activeTab} />
            ) : (
                <div className={styles.emptyState}>
                    <div className={styles.emptyIcon}>
                        <Sparkle size={18} weight="duotone" />
                    </div>
                    <span style={{ fontSize: 13, fontWeight: 500, color: '#374151' }}>
                        Start a new chat
                    </span>
                    <span style={{ fontSize: 12, color: '#9ca3af', lineHeight: 1.6 }}>
                        Ask anything about your inventory, sales, forecasts, or suppliers.
                    </span>
                </div>
            )}
        </div>
    );
};

export default QuickHelpPanel;
